<!-- Right Sidebar -->
<aside id="rightsidebar" class="right-sidebar" [ngClass]="isOpenSidebar ? 'open' : 'close'"
  (clickOutside)="onClickedOutside($event)">
  <div class="rightSidebarClose" (click)="toggleRightSidebar()"><i class="far fa-times-circle"></i></div>
  <div class="demo-skin"
    [ngStyle]="{'position' : 'relative', 'max-height' : maxHeight+'px', 'max-width' : maxWidth+'px'}"
    [perfectScrollbar]>
<!--    <div class="rightSetting">-->
<!--      <p>GENERAL SETTINGS</p>-->
<!--      <ul class="setting-list list-unstyled m-t-20">-->
<!--        <li>-->
<!--          <div class="form-check">-->
<!--            <div class="form-check m-l-10">-->
<!--              <label class="form-check-label">-->
<!--                <input class="form-check-input" type="checkbox" value="" checked> Save-->
<!--                History-->
<!--                <span class="form-check-sign">-->
<!--                  <span class="check"></span>-->
<!--                </span>-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <div class="form-check">-->
<!--            <div class="form-check m-l-10">-->
<!--              <label class="form-check-label">-->
<!--                <input class="form-check-input" type="checkbox" value="" checked> Show-->
<!--                Status-->
<!--                <span class="form-check-sign">-->
<!--                  <span class="check"></span>-->
<!--                </span>-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <div class="form-check">-->
<!--            <div class="form-check m-l-10">-->
<!--              <label class="form-check-label">-->
<!--                <input class="form-check-input" type="checkbox" value="" checked> Auto-->
<!--                Submit Issue-->
<!--                <span class="form-check-sign">-->
<!--                  <span class="check"></span>-->
<!--                </span>-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <div class="form-check">-->
<!--            <div class="form-check m-l-10">-->
<!--              <label class="form-check-label">-->
<!--                <input class="form-check-input" type="checkbox" value="" checked> Show-->
<!--                Status To All-->
<!--                <span class="form-check-sign">-->
<!--                  <span class="check"></span>-->
<!--                </span>-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <div class="rightSetting">
      <p>OPÇÕES DE CORES DO MENUS</p>
      <mat-button-toggle-group class="mt-2" [value]="isDarkSidebar ? 'dark' : 'light'">
        <mat-button-toggle (click)="lightSidebarBtnClick()" value="light">Dia</mat-button-toggle>
        <mat-button-toggle (click)="darkSidebarBtnClick()" value="dark">Noite</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="rightSetting">
      <p>COR DO TEMA</p>
      <mat-button-toggle-group class="mt-2" [value]="isDarTheme ? 'dark' : 'light'">
        <mat-button-toggle (click)="lightThemeBtnClick()" value="light">Dia</mat-button-toggle>
        <mat-button-toggle (click)="darkThemeBtnClick()" value="dark">Noite</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="rightSetting">
      <p>COR DA BARRA</p>
      <ul class="demo-choose-skin choose-theme list-unstyled">
        <li data-theme="white" [ngClass]="{'actived': selectedBgColor === 'white'}" (click)="selectTheme('white')">
          <div class="white-theme white-theme-border"></div>
        </li>
        <li data-theme="black" [ngClass]="{'actived': selectedBgColor === 'black'}" (click)="selectTheme('black')">
          <div class="black-theme"></div>
        </li>
        <li data-theme="purple" [ngClass]="{'actived': selectedBgColor === 'purple'}" (click)="selectTheme('purple')">
          <div class="purple-theme"></div>
        </li>
        <li data-theme="blue" [ngClass]="{'actived': selectedBgColor === 'blue'}" (click)="selectTheme('blue')">
          <div class="blue-theme"></div>
        </li>
        <li data-theme="cyan" [ngClass]="{'actived': selectedBgColor === 'cyan'}" (click)="selectTheme('cyan')">
          <div class="cyan-theme"></div>
        </li>
        <li data-theme="green" [ngClass]="{'actived': selectedBgColor === 'green'}" (click)="selectTheme('green')">
          <div class="green-theme"></div>
        </li>
        <li data-theme="orange" [ngClass]="{'actived': selectedBgColor === 'orange'}" (click)="selectTheme('orange')">
          <div class="orange-theme"></div>
        </li>
      </ul>
    </div>
    <div class="rightSetting">
      <p>VÍDEOS DE TUTORIAL</p>
      <div style="color:SlateBlue; margin-top: 10px;">
        <div>
          <a href="/tutorial-videos/main" target="_self" style="color:SlateBlue;">TODOS OS VÍDEOS</a>
          <br><br>
        </div>
        <!-- Vídeos Varejista -->
        <div *ngIf="authService.currentUserValue.usertype.profileType === 'Administrador' || authService.currentUserValue.usertype.profileType === 'Varejista'">
          <a href="/tutorial-videos/video/DEVOLUCAO_ENTREGA_VAREJISTA" target="_self" style="color:SlateBlue;">DEVOLUÇÃO DA ENTREGA</a>
          <br><br>
          <a href="/tutorial-videos/video/ENTREGA_CAIXAS_SEM_AGENDAMENTO_VAREJISTA" target="_self" style="color:SlateBlue;">ENTREGA DE CAIXAS SEM AGENDAMENTO</a>
          <br><br>
          <a href="/tutorial-videos/video/INTEGRADOR_VAREJISTA" target="_self" style="color:SlateBlue;">INTEGRADOR (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/REGRESSO_EM_MASSA_VAREJISTA" target="_self" style="color:SlateBlue;">REGRESSO EM MASSA (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_BALANCO_VAREJISTA" target="_self" style="color:SlateBlue;">RELATÓRIO BALANÇO (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_EXTRATO_VAREJISTA" target="_self" style="color:SlateBlue;">RELATÓRIO EXTRATO (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_TIMETREND_VAREJISTA" target="_self" style="color:SlateBlue;">RELATÓRIO TIMETREND (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_TIMETREND_LOJA_VAREJISTA" target="_self" style="color:SlateBlue;">RELATÓRIO TIMETREND LOJA (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/REMESSA_EM_MASSA_VAREJISTA" target="_self" style="color:SlateBlue;">REMESSA EM MASSA (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/RETORNO_VALIDACAO_VAREJISTA" target="_self" style="color:SlateBlue;">RETORNO COM VALIDAÇÃO (VAREJISTA)</a>
          <br><br>
          <a href="/tutorial-videos/video/RETORNO_VAREJISTA" target="_self" style="color:SlateBlue;">RETORNO</a>
          <br><br>
          <a href="/tutorial-videos/video/TRANSFERENCIA_ESTADO_VAREJISTA" target="_self" style="color:SlateBlue;">TRANSFERÊNCIA DE ESTADO</a>
          <br><br>
          <a href="/tutorial-videos/video/TRANSFERENCIA_ENTRE_CDS_ENVIANDO_VAREJISTA" target="_self" style="color:SlateBlue;">TRANSFERÊNCIA ENTRE CDS (VAREJISTA) - ENVIANDO</a>
          <br><br>
          <a href="/tutorial-videos/video/TRANSFERENCIA_ENTRE_CDS_RECEBENDO_VAREJISTA" target="_self" style="color:SlateBlue;">TRANSFERÊNCIA ENTRE CDS (VAREJISTA) - RECEBENDO</a>
          <br><br>
        </div>
        <!-- Vídeos Produtor -->
        <div *ngIf="authService.currentUserValue.usertype.profileType === 'Administrador' || authService.currentUserValue.usertype.profileType === 'Produtor'">
          <a href="/tutorial-videos/video/AGENDAMENTO_ENTREGA_PRODUTOR" target="_self" style="color:SlateBlue;">AGENDAMENTO DE ENTREGA (PRODUTOR)</a>
          <br><br>
          <a href="/tutorial-videos/video/AGENDAMENTO_RETIRADA_PRODUTOR" target="_self" style="color:SlateBlue;">AGENDAMENTO RETIRADA (PRODUTOR)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_BALANCO_PRODUTOR" target="_self" style="color:SlateBlue;">RELATÓRIO BALANÇO (PRODUTOR)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_EXTRATO_PRODUTOR" target="_self" style="color:SlateBlue;">RELATÓRIO EXTRATO (PRODUTOR)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_TIMETREND_PRODUTOR" target="_self" style="color:SlateBlue;">RELATÓRIO TIMETREND (PRODUTOR)</a>
          <br><br>
        </div>
        <!-- Vídeos HB -->
        <div *ngIf="authService.currentUserValue.usertype.profileType === 'Administrador' || authService.currentUserValue.usertype.profileType === 'HB'">
          <a href="/tutorial-videos/video/DEVOLUCAO_HB" target="_self" style="color:SlateBlue;">DEVOLUÇÃO (HB)</a>
          <br><br>
          <a href="/tutorial-videos/video/RELATORIO_EXTRATO_HB" target="_self" style="color:SlateBlue;">RELATÓRIO EXTRATO (HB)</a>
          <br><br>
          <a href="/tutorial-videos/video/RETIRADA_HB" target="_self" style="color:SlateBlue;">RETIRADA (HB)</a>
          <br><br>
          <a href="/tutorial-videos/video/TRANSFERENCIA_HB" target="_self" style="color:SlateBlue;">TRANSFERÊNCIA (HB)</a>
          <br><br>
        </div>
      </div>
    </div>
  </div>
</aside>
<!-- #END# Right Sidebar -->
